import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Snackbar as MuiSnackbar } from "@mui/material";
import { Close } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

import { InfoNotificationIcon } from "../../utils/Icons";
import { setPushNotification } from "../../store/Notifications/actions";
import { handleNotificationClick } from "../../notifications/helpers";
import { clickActions } from "../../notifications/constants";
import { logoutRequest } from "../../store/Auth/actions";
import { getDeviceId } from "../../utils/Auth";
import "./NotificationSnackbar.scss";

const NotificationSnackbar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const employeeId = useSelector((state) => state.auth.login?.Id);

  const { show, title, body, clickAction, actionId, id } =
    useSelector((state) => state.notifications.pushNotification);
  useEffect(() => {
    if (
      show &&
      [
        clickActions.accountDeactivated,
        clickActions.permissionsChanged
      ].includes(clickAction)
    ) {
      setTimeout(() => {
        dispatch(
          logoutRequest({
            device_id: getDeviceId(),
            navigate,
            forceLogoutParams: { id: employeeId, isEmployee: true }
          })
        );
      }, 5000);
    }
  }, [show, clickAction]);

  const handleClose = (_, reason) => {
    if (reason === "clickaway") {
      return;
    }
    dispatch(
      setPushNotification({
        show: false,
        id: null,
        title: "",
        body: "",
        clickAction: null,
        actionId: null
      })
    );
  };

  return (
    <div className="notification-snackbar-container">
      {show && (
        <MuiSnackbar
          open={show}
          autoHideDuration={5000}
          onClose={handleClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          className={`notification-snackbar pointer`}
          onClick={() =>
            handleNotificationClick({
              id,
              clickAction,
              actionId,
              navigate
            })
          }
          message={
            <div className="snackbar-msg-icon-container d-flex align-items-start justify-content-between mx-2">
              <div className="d-flex message-container">
                <InfoNotificationIcon className="me-3" />
                <div className="width-fit-content">
                  <p className="mb-0 title fsize-16 fweight-600">
                    {title}
                  </p>
                  <p className="mb-0 body fsize-16">{body}</p>
                </div>
              </div>
              <div
                className="close-icon mx-2 pointer"
                onClick={(e, reason) => {
                  e.stopPropagation();
                  handleClose(e, reason);
                }}>
                <Close />
              </div>
            </div>
          }
        />
      )}
    </div>
  );
};

export default NotificationSnackbar;
